// Cookie Consent Manager for GDPR Compliance

const CONSENT_KEY = 'somar_cookie_consent';
const CONSENT_VERSION = '1.0';

export const CookieCategories = {
  ESSENTIAL: 'essential',
  FUNCTIONAL: 'functional',
  ANALYTICS: 'analytics'
};

export const getConsent = () => {
  try {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) return null;
    
    const consent = JSON.parse(stored);
    if (consent.version !== CONSENT_VERSION) {
      // Version mismatch, require new consent
      return null;
    }
    return consent;
  } catch (e) {
    console.error('Error reading consent:', e);
    return null;
  }
};

export const setConsent = (preferences) => {
  try {
    const consent = {
      version: CONSENT_VERSION,
      timestamp: new Date().toISOString(),
      preferences: {
        [CookieCategories.ESSENTIAL]: true, // Always true
        [CookieCategories.FUNCTIONAL]: preferences.functional || false,
        [CookieCategories.ANALYTICS]: preferences.analytics || false
      }
    };
    
    localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
    
    // Apply consent immediately
    applyConsent(consent.preferences);
    
    return consent;
  } catch (e) {
    console.error('Error saving consent:', e);
    return null;
  }
};

export const clearConsent = () => {
  try {
    localStorage.removeItem(CONSENT_KEY);
  } catch (e) {
    console.error('Error clearing consent:', e);
  }
};

export const hasConsent = (category) => {
  const consent = getConsent();
  if (!consent) return false;
  return consent.preferences[category] === true;
};

export const acceptAll = () => {
  return setConsent({
    functional: true,
    analytics: true
  });
};

export const rejectNonEssential = () => {
  return setConsent({
    functional: false,
    analytics: false
  });
};

const applyConsent = (preferences) => {
  // Log analytics consent for Vercel Analytics
  if (preferences.analytics) {
    console.log('Analytics consent granted - Vercel Analytics will be enabled');
  } else {
    console.log('Analytics consent denied - Vercel Analytics disabled');
  }
  
  // Dispatch event for other parts of the app
  window.dispatchEvent(new CustomEvent('cookieConsentChanged', { 
    detail: preferences 
  }));
};

// Check and apply consent on page load
export const initializeConsent = () => {
  const consent = getConsent();
  if (consent) {
    applyConsent(consent.preferences);
  }
};
